/* eslint-disable react/prop-types, react/no-danger */

import React from 'react';
import PropTypes from 'prop-types';
import VideoMessage from '@/components/message/items/video-message';
import AudioMessage from '@/components/message/items/audio-message';
import ProjectMessage from '@/components/message/items/project-message';
import NormalMessage from '@/components/message/items/normal-message';
import SendingMessage from '@/components/message/items/sending-message';

// 匹配资源地址
const matchSrc = (content) => {
  const reg = /\([^(]*\)/g;
  const arr = content.match(reg);
  if (arr) {
    return content.match(reg).map((url) => url.replace(/[(|)]/g, ''));
  }
  return null;
};

// 替换资源地址
const replaceUrl = (content, type) => {
  // noinspection RegExpRedundantEscape
  const replaceUrlReg = /!\[url\]\([^(]*\)/g;
  // noinspection RegExpRedundantEscape
  const replaceImg = /!\[image\]\([^(]*\)/g;
  const srcs = matchSrc(content);
  if (!srcs) {
    return content;
  }
  let c = content.replace(
    type === 'img' ? replaceImg : replaceUrlReg,
    '[placeholder]'
  );
  c = c.trim();
  srcs.forEach((src) => {
    c = c.replace(
      '[placeholder]',
      type === 'img'
        ? `<a href=${src} target='_blank'><img src=${src} alt=""/></a>`
        : `<a href=${src} class="ms-answer" target="_blank">${src}</a>`
    );
  });
  return c;
};

// 拼装模板
const assembleTem = (content) => {
  let c = content;
  c = replaceUrl(c, 'link');
  c = replaceUrl(c, 'img');
  return c;
};

/**
 * @param {{message: IMessage, online: boolean}} props
 * @return {JSX.Element|null}
 * @constructor
 */
const MessageItem = (props) => {
  const { message, online } = props;
  let robotAvatar = false;
  if (message.messageType === 'system' && !message.fromMe) {
    message.avatar = 'https://m.xiguacity.cn/avatar/head.png';
    robotAvatar = true;
  }

  let avatarClassName;
  if (online) {
    avatarClassName = 'ms-avatar';
  } else if (robotAvatar) {
    avatarClassName = 'ms-avatar';
  } else {
    avatarClassName = 'ms-avatar offline';
  }

  if (
    message.contentType === 'audio'
    || message.message_content_type === 'audio'
  ) {
    return (
      <AudioMessage
        error={message.error || false}
        msgContent={message.msgContent || {}}
        fromMe={message.fromMe}
        avatar={message.avatar}
        avatarClassName={avatarClassName}
        senderOid={message.senderOid}
        senderType={message.senderType}
        duration={message.fileLength}
        audioUri={message.content}
      />
    );
  }

  if (
    message.contentType === 'video'
    || message.message_content_type === 'video'
  ) {
    return (
      <VideoMessage
        fromMe={message.fromMe}
        avatar={message.avatar}
        avatarClassName={avatarClassName}
        senderOid={message.senderOid}
        senderType={message.senderType}
        url={message.content}
      />
    );
  }

  if (
    message.contentType === 'file'
    || message.message_content_type === 'file'
  ) {
    return (
      <ProjectMessage
        error={message.error || false}
        msgContent={message.msgContent || {}}
        fromMe={message.fromMe}
        avatar={message.avatar}
        avatarClassName={avatarClassName}
        senderOid={message.senderOid}
        senderType={message.senderType}
        message={message.content}
      />
    );
  }

  if (message.contentType === 'placeholder-loading') {
    return (
      <SendingMessage
        fromMe={message.fromMe}
        avatar={message.avatar}
        avatarClassName={avatarClassName}
        senderOid={message.senderOid}
        senderType={message.senderType}
      />
    );
  }

  let messageContent;
  const isImgMessage = (/^<img/.test(message.content)
    || /<img/.test(message.content))
    && !/<p>/.test(message.content.replace(/<p><\/p>/g, '')); // 适配教师端Im：把包含img元素的信息中所有空p元素过滤掉后没有p元素了,那么就是纯图片信息

  // noinspection RegExpRedundantEscape
  if (/!\[image\]/.test(message.content) || /!\[url\]/.test(message.content)) {
    messageContent = <Content content={assembleTem(message.content)} />;
  } else if (/\/scratch#/.test(message.content)) {
    messageContent = <Content content="【向老师发送了工程文件求助】" />;
  } else {
    const { content } = message;
    messageContent = <Content content={content} />;
  }

  if (!message.content) return null;

  return (
    <NormalMessage
      error={message.error || false}
      msgContent={message.msgContent || {}}
      fromMe={message.fromMe}
      avatar={message.avatar}
      avatarClassName={avatarClassName}
      senderOid={message.senderOid}
      senderType={message.senderType}
      isImgMessage={isImgMessage}
    >
      {messageContent}
    </NormalMessage>
  );
};

MessageItem.propTypes = {
  message: PropTypes.shape({
    messageType: PropTypes.string,
    avatar: PropTypes.string,
    fileLength: PropTypes.number,
    fromMe: PropTypes.bool,
    content: PropTypes.string,
  }),
  online: PropTypes.bool,
};

// const TextContent = (props) => {
//   const { content } = props;
//   return <div style={{ wordBreak: 'break-all' }}>{content}</div>;
// };

const Content = (props) => {
  const { content } = props;
  return (
    <div
      dangerouslySetInnerHTML={{ __html: content }}
      style={{ wordBreak: 'break-all' }}
    />
  );
};

Content.propTypes = {
  content: PropTypes.any,
};

export default MessageItem;
